import React, {Component} from 'react';

import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin); 

const scrolling = (event) => {
    if (window.scrollY === 0){
        document.body.classList.remove('scrolling');
    } else if (window.scrollY > 40 ){
        document.body.classList.add('scrolling');
    }
};
class ScrollToTop extends Component {

    componentDidMount() {
        scrolling();
        window.addEventListener('scroll', scrolling);
    }

    render () {

        function goToTop(e) {
            e.preventDefault();
            gsap.to(window, {duration: 0.5, scrollTo: 0 });
        }

        return (
           <a  
                onClick={goToTop}
                className="scroll-to-top arrow-anim" 
                title="back to top">
                back to top 
                <i className="icon icon-line-arrow-right"></i>
           </a>
        );
    }
}

export default ScrollToTop;


// WEBPACK FOOTER //
// ./src/components/ScrollToTop/ScrollToTop.js